import { handleActions } from 'redux-actions';
import { fetchDetailedOffersResponse } from 'shared/store/modules/offers/actions';

const defaultState = {};

export default handleActions(
  {
    [fetchDetailedOffersResponse]: {
      next: (state, { payload }) => ({
        ...state,
        [payload.utilityId]: payload.offers
      })
    }
  },
  defaultState
);
